import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faTruck } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from '../../../context/AppContext';
import { postData } from '../../../services';
import { useState } from 'react';
import Modal from '../../helpers/Modal';
const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

export const OrderShippedAlertForm = ({ project }) => {
    const { token, base_url } = useAppContext();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const trimmed = email.trim();
        if (!trimmed) {
            window.showAlert(400, 'Please enter an email address.');
            return;
        }
        if (!isValidEmail(trimmed)) {
            window.showAlert(400, 'Please enter a valid email address.');
            return;
        }

        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            const url = `${base_url}/apis/alerts/order-shipped/${encodeURIComponent(trimmed)}/${project.id}`;
            const response = await postData(token, url, {});

            if (!response) {
                window.showAlert(500, 'Failed to send shipping alert. Please try again.');
                return;
            }

            if (response.msg) {
                window.showAlert(200, response.msg);
                setEmail('');
                setIsModalOpen(false);
            } else if (response.detail) {
                window.showAlert(400, typeof response.detail === 'string' ? response.detail : 'Unable to send shipping alert.');
            } else {
                window.showAlert(400, 'Unable to send shipping alert. Please try again.');
            }
        } catch (error) {
            console.error('Error sending order shipped alert:', error);
            window.showAlert(500, 'Failed to send shipping alert. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const orderShippedAlertForm = (
        <div>
            <h2>Order Shipped Alert</h2>
            <p>Send an order shipped notification email to a single recipient for this project.</p>
            <p><strong>Project: {project?.project_name}</strong></p>

            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="orderShippedAlertEmail" className="form-label">
                        Recipient email
                    </label>
                    <input
                        id="orderShippedAlertEmail"
                        type="email"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="form-control"
                        placeholder="name@example.com"
                        autoComplete="email"
                        required
                    />
                </div>

                <div className="form-actions">
                    <button
                        type="button"
                        onClick={() => setIsModalOpen(false)}
                        className="btn btn-secondary"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? (
                            <>
                                <FontAwesomeIcon icon={faSpinner} spin /> Sending...
                            </>
                        ) : (
                            'Send alert'
                        )}
                    </button>
                </div>
            </form>
        </div>
    );

    return (
        <>
            <button
                type="button"
                onClick={() => setIsModalOpen(true)}
                className="btn btn-secondary"
                title="Order Shipped Alert"
            >
                <FontAwesomeIcon icon={faTruck} />
                &nbsp;shipping alert
            </button>
            {isModalOpen && (
                <Modal form={orderShippedAlertForm} setIsModalOpen={setIsModalOpen} />
            )}
        </>
    );
};
